import { useEffect, useState } from 'react';
import {
  birimlerAPI, urunTipleriAPI,
  malzemeTipleriAPI, cariTipleriAPI, kdvOranlariAPI,
  paketlemeTipleriAPI, faturaDurumlariAPI
} from '../services/api';

const toOptions = (rows) => rows.map(r => ({ value: r.id, label: r.ad }));
const kdvToOptions = (rows) => rows.map(k => ({ value: k.id, label: '%' + Number(k.oran) }));

export function useLookups() {
  const [birimler, setBirimler] = useState([]);
  const [urunTipleri, setUrunTipleri] = useState([]);
  const [malzemeTipleri, setMalzemeTipleri] = useState([]);
  const [cariTipleri, setCariTipleri] = useState([]);
  const [kdvOranlari, setKdvOranlari] = useState([]);
  const [paketlemeTipleri, setPaketlemeTipleri] = useState([]);
  const [faturaDurumlari, setFaturaDurumlari] = useState([]);

  useEffect(() => {
    birimlerAPI.getAll().then(r => setBirimler(r.data)).catch(() => {});
    urunTipleriAPI.getAll().then(r => setUrunTipleri(r.data)).catch(() => {});
    malzemeTipleriAPI.getAll().then(r => setMalzemeTipleri(r.data)).catch(() => {});
    cariTipleriAPI.getAll().then(r => setCariTipleri(r.data)).catch(() => {});
    kdvOranlariAPI.getAll().then(r => setKdvOranlari(r.data)).catch(() => {});
    paketlemeTipleriAPI.getAll().then(r => setPaketlemeTipleri(r.data)).catch(() => {});
    faturaDurumlariAPI.getAll().then(r => setFaturaDurumlari(r.data)).catch(() => {});
  }, []);

  return {
    birimler,
    urunTipleri,
    malzemeTipleri,
    cariTipleri,
    kdvOranlari,
    paketlemeTipleri,
    faturaDurumlari,
    birimOptions: toOptions(birimler),
    urunTipiOptions: toOptions(urunTipleri),
    malzemeTipiOptions: toOptions(malzemeTipleri),
    cariTipiOptions: toOptions(cariTipleri),
    kdvOptions: kdvToOptions(kdvOranlari),
    paketlemeTipiOptions: toOptions(paketlemeTipleri),
    faturaDurumuOptions: toOptions(faturaDurumlari),
  };
}
